import { em, math } from 'polished'
import styled from 'styled-components'

import { TextLH } from 'styles/components/typography'

import CartItemLayout from '../CartItemLayout'

export const CartItemLayoutStyled = styled(CartItemLayout)`
  ${p => p.theme.mq.upMd} {
    border-bottom: 1px solid ${p => p.theme.colors.blackOp07};
  }
`

export const TextBlock = styled.div`
  display: flex;
  justify-content: left;

  ${p => p.theme.mq.upMd} {
    position: relative;
    display: block;
  }

  ${p => p.theme.mq.upLg} {
    max-width: ${em(230)};
  }
`

export const IconBlock = styled.div`
  position: relative;
  flex: 0 0 auto;
  line-height: 0;
  width: ${p => p.theme.blocks.iconInfoW};
  height: ${p => p.theme.blocks.iconInfoW};
  margin-right: ${em(10)};

  ${p => p.theme.mq.upMd} {
    position: absolute;
    top: ${em(5)};
    left: ${p => math(`-${p.theme.blocks.iconInfoW} - ${em(10)}`)};
    margin-right: 0;
  }
`

export const Text = styled(TextLH)`
  display: inline-block;
  position: relative;
  // Align top icon and text
  top: -0.2em;

  ${p => p.theme.mq.upMd} {
    display: inline;
    position: static;
  }
`
